import { buildCategoryFieldSuggestions, } from './headless-category-field-suggestions.js';
export * from './headless-category-field-suggestions.js';
/**
 * Defines a `CategoryFieldSuggestions` controller instance.
 * @group Definers
 *
 * @param props - The configurable `CategoryFieldSuggestions` properties.
 * @returns The `CategoryFieldSuggestions` controller definition.
 * */
export function defineCategoryFieldSuggestions(props) {
    return {
        build: (engine) => buildCategoryFieldSuggestions(engine, props),
    };
}
